import { axiosApi } from '../globals';

export namespace pricing {
  export const get = () => {
    return axiosApi.run('get', '/Subscription/List');
  };
}
